import cx from 'classnames'
import { match } from '@/utils/pattern-match-util'
import { RawButton } from '@/components/Button'
import { Card, CardContent } from '@/components/Card'
import styles from './StatusFilterCards.module.css'

/**
 * The accent color under a status card.
 */
export type StatusFilterCardTone = 'Blue' | 'Green' | 'Red' | 'Grey'

export interface StatusFilterCardOption {
  key: string
  title: string
  count?: number
  tone: StatusFilterCardTone
  testId?: string
  onSelect: () => void
}

export interface StatusFilterCardsProps {
  title: string
  selectedKey: string
  options: StatusFilterCardOption[]
}

export function StatusFilterCards({
  title,
  selectedKey,
  options,
}: StatusFilterCardsProps) {
  return (
    <div className={styles.root}>
      <h1>{title}</h1>
      <div className={styles.cardsContainer}>
        {options.map((opt) => (
          <StatusFilterCard
            key={opt.key}
            title={opt.title}
            count={opt.count}
            tone={opt.tone}
            isActive={selectedKey === opt.key}
            testId={opt.testId}
            onSelect={opt.onSelect}
          />
        ))}
      </div>
    </div>
  )
}

interface StatusFilterCardProps {
  title: string
  count?: number
  tone: StatusFilterCardTone
  isActive: boolean
  testId?: string
  onSelect: () => void
}

function StatusFilterCard({
  title,
  count,
  tone,
  isActive,
  testId,
  onSelect,
}: StatusFilterCardProps) {
  return (
    <RawButton
      className={cx(styles.filterCardContainer, isActive && styles.active)}
      onPress={onSelect}
      testId={testId}
    >
      <Card borderless>
        <CardContent compact>
          <div className={cx(styles.filterCardContent, toneClassName(tone))}>
            <h2>{title}</h2>
            <h1>{count}</h1>
          </div>
        </CardContent>
      </Card>
    </RawButton>
  )
}

function toneClassName(tone: StatusFilterCardTone) {
  return match(tone, {
    Blue: styles.toneBlue,
    Green: styles.toneGreen,
    Red: styles.toneRed,
    Grey: styles.toneGrey,
  })
}
